export default {
  title: {
    en: 'Upgrade',
  },
  newTitle: {
    en: 'Upgrade your plan',
  },
}
